import { Chip } from '@heidi/design-system/chip';
import { StatusIndicator } from '@heidi/design-system/status-indicator';
import type { ClinicalTaskCategory } from '@heidi/schema/ml-scribe';
import { defineMessages, useIntl } from 'react-intl';
import { clinicalTaskCategoryColor } from './clinical-task-chip-colors';

const categoryMessages = defineMessages({
  order: {
    defaultMessage: 'Order',
    id: 'uas66kr/yZ',
    description: 'Clinical task category label: order',
  },
  coordinate: {
    defaultMessage: 'Coordinate',
    id: 'PBiX6LqjMs',
    description: 'Clinical task category label: coordinate',
  },
  communicate: {
    defaultMessage: 'Communicate',
    id: 'Vk8WuOB4/g',
    description: 'Clinical task category label: communicate',
  },
  document: {
    defaultMessage: 'Document',
    id: 'DhgI+p0zi6',
    description: 'Clinical task category label: document',
  },
  action: {
    defaultMessage: 'Action',
    id: 'FWdIEArYUZ',
    description: 'Clinical task category label: action',
  },
  prescription: {
    defaultMessage: 'Prescription',
    id: 'msWv5PGAm6',
    description: 'Clinical task category label: prescription',
  },
} satisfies Record<ClinicalTaskCategory, unknown>);

interface ClinicalTaskCategoryChipProps {
  /** Unknown keys render nothing. */
  category?: string | null;
  className?: string;
}

/** Read-only twin of `ClinicalTaskCategorySelectorV2`'s rest state. */
export const ClinicalTaskCategoryChip = ({
  category,
  className,
}: ClinicalTaskCategoryChipProps) => {
  const intl = useIntl();

  if (!category || !Object.hasOwn(clinicalTaskCategoryColor, category)) return null;

  const categoryKey = category as ClinicalTaskCategory;
  const color = clinicalTaskCategoryColor[categoryKey];

  return (
    <Chip
      color={color}
      variant="ghost"
      leadingIcon={<StatusIndicator marker="dot" size="xs" markerColor={color} />}
      className={className}
    >
      {intl.formatMessage(categoryMessages[categoryKey])}
    </Chip>
  );
};
